import React from 'react';
import Icon, { IconProps } from '../Icon';

const SearchIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99996 10.9201C5.00314 10.9201 4.02871 10.6245 3.19989 10.0707C2.37107 9.5169 1.72508 8.72975 1.34361 7.80882C0.962145 6.88788 0.862336 5.8745 1.05681 4.89683C1.25127 3.91917 1.73129 3.02113 2.43615 2.31627C3.141 1.61142 4.03904 1.1314 5.01671 0.936932C5.99437 0.742463 7.00775 0.842272 7.92869 1.22374C8.84963 1.6052 9.63677 2.25119 10.1906 3.08002C10.7444 3.90884 11.04 4.88327 11.04 5.88009C11.04 7.21678 10.509 8.49873 9.56378 9.44391C8.6186 10.3891 7.33665 10.9201 5.99996 10.9201ZM5.99996 1.96009C5.22466 1.96009 4.46677 2.18999 3.82213 2.62073C3.17749 3.05146 2.67505 3.66369 2.37836 4.37997C2.08166 5.09626 2.00403 5.88444 2.15528 6.64485C2.30654 7.40525 2.67988 8.10373 3.2281 8.65195C3.77633 9.20017 4.4748 9.57352 5.23521 9.72477C5.99561 9.87602 6.78379 9.79839 7.50008 9.5017C8.21637 9.205 8.82859 8.70257 9.25932 8.05793C9.69006 7.41329 9.91996 6.65539 9.91996 5.88009C9.91996 4.84044 9.50696 3.84337 8.77182 3.10823C8.03668 2.37309 7.03961 1.96009 5.99996 1.96009Z"
          fill="currentColor"
        />
        <path
          d="M12.4204 13.1601C12.2721 13.1595 12.1302 13.1001 12.0256 12.9949L8.63762 9.6069C8.58559 9.55487 8.54432 9.4931 8.51616 9.42512C8.488 9.35714 8.47351 9.28428 8.47351 9.2107C8.47351 9.13712 8.488 9.06426 8.51616 8.99628C8.54432 8.9283 8.58559 8.86653 8.63762 8.8145C8.68965 8.76247 8.75142 8.7212 8.8194 8.69304C8.88738 8.66488 8.96024 8.65039 9.03382 8.65039C9.1074 8.65039 9.18026 8.66488 9.24824 8.69304C9.31622 8.7212 9.37799 8.76247 9.43002 8.8145L12.818 12.2025C12.897 12.2808 12.9509 12.3809 12.9727 12.49C12.9946 12.599 12.9835 12.7121 12.9409 12.8148C12.8982 12.9176 12.8259 13.0053 12.7332 13.0668C12.6406 13.1283 12.5317 13.1607 12.4204 13.1601Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default SearchIcon;
